import React from 'react';
import { useSelector } from 'react-redux';
import { UserAccessError } from '../../model/constants';

const UserStatusPopup = () => {
    const { userLoginError } = useSelector(state => state.configurator);

    const getUserError = () => {
        const error = userLoginError?.error;

        switch (error) {
            case UserAccessError.InvalidToken:
                return 'La sesión ha caducado. Por favor, vuelva al área de usuario para volver a acceder.';
            case UserAccessError.UnitNotFound:
                return 'La vivienda no ha sido encontrada. En caso de duda, póngase en contacto con su comercial.';
            default:
                return 'Se ha producido un error al acceder al configurador.';
        }
    };

    const getUserToken = () => {
        const token = userLoginError?.token;
        return `token: ${token}`;
    };

    return (
      <div className="user-status-popup">
        <div className="background" />
        <div className="panel">
          <div className="header">Acceso de usuario</div>
          <div className="subheader1">{getUserError()}</div>
          <div className="subheader2">{getUserToken()}</div>
        </div>
      </div>
    );
};

export default UserStatusPopup;
